import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-changelog-search',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './changelog-search.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./changelog-search.component.scss'],
})
export class ChangelogSearchComponent {
  @Output() searchChange = new EventEmitter<string>();
  searchQuery = '';

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value;
    this.searchChange.emit(this.searchQuery);
  }

  clearSearch() {
    this.searchQuery = '';
    this.searchChange.emit('');
  }
}
